let mousex: number, mousey: number;
let mousehidden = false, mousewashidden = true;
let $cloned_mouselink: JQuery | undefined,
    $orig_mouselink: JQuery | undefined;

function updateMouseLink() {
    if(!$cloned_mouselink || !$cloned_mouselink.length)
        return;
    if(mousewashidden != mousehidden) {
        mousewashidden = mousehidden;
        $cloned_mouselink.toggleClass('xhidden', mousehidden);
    }
    if(mousex == undefined || mousey == undefined)
        return;
    const pos = {left: 'auto', top: 'auto', right: 'auto', bottom: 'auto'};
    if(mousex + $cloned_mouselink.width()! > window.innerWidth)
        pos.right = (window.innerWidth-mousex)+'px';
    else
        pos.left = mousex+'px';
    if(mousey + $cloned_mouselink.height()! > window.innerHeight)
        pos.bottom = (window.innerHeight-mousey)+'px';
    else
        pos.top = mousey+'px';
    $cloned_mouselink.css(pos);
}

function set($new_mouselink: JQuery | undefined) {
    if($orig_mouselink?.[0] == $new_mouselink?.[0])
        return;
    if($cloned_mouselink) {
        const $previous_mouselink = $cloned_mouselink;
        $previous_mouselink.addClass('xhidden');
        setTimeout(() => $previous_mouselink.remove(), 1000);
    }
    if($new_mouselink) {
        $orig_mouselink = $new_mouselink;
        $cloned_mouselink = $new_mouselink.clone().detach();
        $cloned_mouselink.addClass('xhidden');
        mousewashidden = true;
        setTimeout(() => {
            $cloned_mouselink!.appendTo('body');
            if(!mousehidden)
                $cloned_mouselink!.removeClass('xhidden');
        }, 0);
    } else {
        $cloned_mouselink = $orig_mouselink = undefined;
    }
    updateMouseLink();
};

function remove() {
    set(undefined);
}

$('.with-mouse-links').on('mousemove', (e) => {
    mousex = e.clientX;
    mousey = e.clientY;
    updateMouseLink();
});
$('.with-mouse-links .fullscreen-link').on('mousemove', function() {
    set($(this).siblings('.mouse-link').first());
}).on('mouseenter', () => {
    mousehidden = false;
    updateMouseLink();
}).on('mouseleave', () => {
    mousehidden = true;
    updateMouseLink();
});

export {set, remove};
